// extracted by mini-css-extract-plugin
module.exports = {"singleSelect":"searchSelect_singleSelect__1h4Ep"};